import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./pages/Login";
import MainLayout from "./components/MainLayout";
import Enquiries from "./pages/Enquiries";
import ViewEnq from "./pages/ViewEnq";
import { PrivateRoutes } from "./routing/PrivateRoutes";
import { OpenRoutes } from "./routing/OpenRoutes";
import { useEffect, useState } from "react";
 
import Bookings from "./pages/Bookings";
import ViewBooking from "./pages/ViewBooking";
import OnlineVisitors from "./pages/OnlineVisitors";
import Preloader from "./components/Preloader";
import AddProject from "./pages/AddProject";
import Projects from "./pages/Projects";
 
function App() {

  const [loading, setLoading] = useState(true);

  

    const handleAnimationComplete = () => {
    setLoading(false);
  };

  return (
    <Router>

            {loading ? (    
          <>
           
            <Preloader onAnimationComplete={handleAnimationComplete} />
          </>
           ) : (
      <>
 
      <Routes>
        <Route path="/" element={<OpenRoutes><Login /></OpenRoutes>} />
        <Route path="/admin" element={<PrivateRoutes><MainLayout /></PrivateRoutes>}>
          <Route index element={<Enquiries />} />
          <Route path="enquiries" element={<Enquiries />} />
          <Route path="enquiries/:id" element={<ViewEnq />} />
          <Route path="bookings" element={<Bookings />} />
          <Route path="online-visitors" element={<OnlineVisitors />} />
          <Route path="add-project" element={<AddProject />} />
           <Route path="add-project/:slug" element={<AddProject />} />
   
          <Route path="projects-list" element={<Projects />} />

          <Route path="bookings/:id" element={<ViewBooking />} />
        </Route>
      </Routes>
      </>)}
    </Router>
  );
}

export default App;
